// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","btn":"yGux2h","icon":"tQsEr7","AniFadeIn":"EDq6S0","AniFadeOut":"FveHsQ","AniRotate":"_6PXIZL","AniPlaceholderFadeOut":"YDJWjZ"};